import { FormlyFieldConfig } from '@ngx-formly/core';

export function tinValidatorMessage(error: unknown, field: FormlyFieldConfig): string {
  return 'Taxpayer Identification Number (TIN) must be between 8 to 15 characters';
}
